import { render } from "./BestiaryModal.vue?vue&type=template&id=5f08a7c2&scoped=true"
import script from "./BestiaryModal.vue?vue&type=script&lang=js"
export * from "./BestiaryModal.vue?vue&type=script&lang=js"

import "./BestiaryModal.vue?vue&type=style&index=0&id=5f08a7c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f08a7c2"]])

export default __exports__